// import register from './register';
import query from './query';
import my from './my';
import demo from './demo';
// import update from './update';
// import operation from './operation';
export default {
  // register,
  query,my
  // demo,update,operation
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js